"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyFormat = exports.currencyRuLocaleWithoutFraction = exports.numFormat = void 0;
const numFormat = (number) => new Intl.NumberFormat('ru-RU').format(number);
exports.numFormat = numFormat;
const currencyRuLocaleWithoutFraction = (number, options = { maxFraction: 0, minFraction: 0 }) => new Intl.NumberFormat('ru-RU', {
    currency: 'RUB',
    style: 'currency',
    maximumFractionDigits: options.maxFraction,
    minimumFractionDigits: options.minFraction,
}).format(number);
exports.currencyRuLocaleWithoutFraction = currencyRuLocaleWithoutFraction;
const currencyFormat = (number) => {
    if (number > 1000000) {
        const truncNumber = Math.floor(number / 1000000);
        return `${(0, exports.numFormat)(truncNumber)} млн`;
    }
    return (0, exports.numFormat)(number);
};
exports.currencyFormat = currencyFormat;
